/*eslint-disable*/
export default {
  init() {
    // ===== HAMBURGER MENU =====
    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      $('html').toggleClass('menu-open');
      $('html').ontouchend = (e) => {
        e.preventDefault();
      }
    });


    $(".gallery__container .wysiwyg iframe").wrap("<div class='video-wysiwyg'></div>");

    $(window).scroll(function () {
      // Get number of pixels of scroll.
      var pixel = $(window).scrollTop();
      // When the scroll exceeds 300px, give the [fixed-menu] class.
      if (pixel > 155) {
        $('.c-header__nav').addClass('fixed-menu');
        $('.c-header__logo--white').addClass('u-visually-hidden');
        $('.c-header__logo--dark').removeClass('u-visually-hidden');
        $('.eshop-white').addClass('u-visually-hidden');
        $('.eshop-black').removeClass('u-visually-hidden');
        $('.c-nav__fixed-eshop').removeClass('u-visually-hidden');
      } else {
        $('.c-header__nav').removeClass('fixed-menu');
        $('.c-header__logo--white').removeClass('u-visually-hidden');
        $('.c-header__logo--dark').addClass('u-visually-hidden');
        $('.eshop-white').removeClass('u-visually-hidden');
        $('.eshop-black').addClass('u-visually-hidden');
        $('.c-nav__fixed-eshop').addClass('u-visually-hidden');
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js